export const showMoreArticles = () => {
  const desktopBtn = document.querySelector('.page_media .btn_container_desktop .btn')
  const mobileBtn = document.querySelector('.page_media .btn_container_mobile .btn')

  if (desktopBtn) {
    desktopBtn.addEventListener('click', () => {
      const hiddenItems = desktopBtn.closest('.list_articles').querySelectorAll('ul .article_item.hide-item')
      for (let i = 0; i < 5; i++) {
        if (hiddenItems[i]) {
          hiddenItems[i].classList.add('show-item')
          hiddenItems[i].classList.remove('hide-item')
        }
        if (!hiddenItems[i + 1]) {
          desktopBtn.classList.add('hide')
        }
      }
    })
  }
  if (mobileBtn) {
    mobileBtn.addEventListener('click', () => {
      const hiddenItems = mobileBtn.closest('.articles_container').querySelectorAll('.list_articles ul .article_item.hide-item')
      for (let i = 0; i < 5; i++) {
        if (hiddenItems[i]) {
          hiddenItems[i].classList.add('show-item')
          hiddenItems[i].classList.remove('hide-item')
        }
        if (!hiddenItems[i + 1]) {
          mobileBtn.classList.add('hide')
        }
      }
    })
  }
}
